// @ai-generated 2026-10-08T09:40:29+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
import { type SelectOption } from '@synqo/frontend-component-library';

export type ContainerStockTableModes = 'stock' | 'planned';

export const containerStockTableModes: SelectOption<ContainerStockTableModes>[] = [
    {
        name: 'stock',
        label: 'Bestand',
        value: 'stock',
    },
    {
        name: 'planned',
        label: 'Geplante Aktionen',
        value: 'planned',
    },
];
